// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"ec7cb94d","75":"e9be0c86","103":"7007edf7","242":"ddbb61b0","270":"d431e888","382":"41d8899f","423":"f78be640","455":"371825cd","521":"613c3d0f","523":"b126235f","659":"f7675f46","691":"d545c723","797":"5afefbc9","847":"7b55f9d1"}[chunkId] + ".chunk.js";
};